import { all, fork } from 'redux-saga/effects';
import list from './list';
import optionsList from './optionsList';
import citiesOfCountry from './citiesOfCountry';

export default function* events() {
  yield all([fork(list), fork(optionsList), fork(citiesOfCountry)]);
}
